import * as React from 'react';
import * as styles from './styles.css';

import { Header5, InlineText2 } from '@cian/ui-kit/typography';
import { ILocation } from '../../../../types/location';

export interface ISuggestProps {
  suggest: ILocation[];
  onItemClick(value: ILocation): void;
}

export function Suggest({ suggest, onItemClick }: ISuggestProps) {
  return (
    <div className={styles['suggest']} data-testid="suggest-popup">
      {suggest.map(item => {
        const onClick = () => onItemClick(item);

        return (
          <div key={item.id} className={styles['suggest-item']} onClick={onClick} data-testid="item">
            <InlineText2>{item.displayName}</InlineText2>
          </div>
        );
      })}
      {!suggest.length && (
        <div className={styles['suggest-error']} data-testid="error">
          <Header5>Ничего не найдено</Header5>
          <InlineText2>Укажите другой город или регион</InlineText2>
        </div>
      )}
    </div>
  );
}
